// extracted by mini-css-extract-plugin
module.exports = {"preview":"TypeMapping_preview__H1H8K","summaryExistent":"TypeMapping_summaryExistent__mJysa","summaryNew":"TypeMapping_summaryNew__2h5d8"};